import Button from "components/FormElements/Button";
import React from "react";
import AlertInfo from "components/ContentAlerts/AlertInfo";

function BillingInfoModal({ setOpenModal, title, billingAddress }) {
  return (
    <div className="fixed inset-0 z-10 overflow-y-auto ">
      <div className="flex items-end justify-center min-h-screen pt-4 pb-20 text-center sm:block sm:p-0 ">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75" />
        </div>
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        ></span>
        <div
          className="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
          style={{ overflow: "initial" }}
        >
          <div className="bg-white rounded-md">
            <div className="flex items-center justify-between px-3 py-3 border-b border-makdosSecondaryGray">
              <h3 className="text-xl font-medium">{title} Fatura</h3>
              <i
                onClick={() => setOpenModal(false)}
                className="text-2xl cursor-pointer ri-close-line text-passive"
              ></i>
            </div>

            <div className="flex flex-col items-center justify-center w-full px-5 pt-4 pb-5 ">
              <div className="grid w-full grid-cols-8 gap-5">
                <div className="flex justify-between col-span-2">
                  <p>Adres Türü</p>
                  <p>:</p>
                </div>
                <div className="col-span-6">
                  <p>{billingAddress?.is_personal ? "Kişisel" : "Kurumsal"}</p>
                </div>
                <div className="flex justify-between col-span-2">
                  <p>Ad Soyad</p>
                  <p>:</p>
                </div>
                <div className="col-span-6">
                  <p>{billingAddress?.name} {billingAddress?.surname} </p>
                </div>
                <div className="flex justify-between col-span-2">
                  <p>TC Kimlik No</p>
                  <p>:</p>
                </div>
                <div className="col-span-6">
                  <p>{billingAddress?.tc_no?.slice(0, 7)}****</p>
                </div>
                {billingAddress?.company_name !== "" &&
                  <>
                    < div className="flex justify-between col-span-2">
                      <p>Firma Ünvanı</p>
                      <p>:</p>
                    </div>
                    <div className="col-span-6">
                      <p>{billingAddress.company_name}</p>
                    </div>
                  </>
                }
                {billingAddress?.tax_office !== "" &&
                  <>
                    < div className="flex justify-between col-span-2">
                      <p>Vergi Dairesi</p>
                      <p>:</p>
                    </div>
                    <div className="col-span-6">
                      <p>{billingAddress.tax_office}</p>
                    </div>
                  </>
                }
                {billingAddress.tax_no !== "" &&
                  <>
                    < div className="flex justify-between col-span-2">
                      <p>Vergi No</p>
                      <p>:</p>
                    </div>
                    <div className="col-span-6">
                      <p>{billingAddress.tax_no?.slice(0, 6)}****</p>
                    </div>
                  </>
                }

                <div className="flex justify-between col-span-2">
                  <p>Ülke</p>
                  <p>:</p>
                </div>
                <div className="col-span-6">
                  <p>{billingAddress?.country?.text}</p>
                </div>
                <div className="flex justify-between col-span-2">
                  <p>İl</p>
                  <p>:</p>
                </div>
                <div className="col-span-6">
                  <p>{billingAddress?.state?.text}</p>
                </div>
                <div className="flex justify-between col-span-2">
                  <p>İlçe</p>
                  <p>:</p>
                </div>
                <div className="col-span-6">
                  <p>{billingAddress?.cities?.text}</p>
                </div>
                <div className="flex justify-between col-span-2">
                  <p>Posta Kodu</p>
                  <p>:</p>
                </div>
                <div className="col-span-6">
                  <p>{billingAddress?.post_code}</p>
                </div>
                <div className="flex justify-between col-span-2">
                  <p>Adres</p>
                  <p>:</p>
                </div>
                <div className="col-span-6">
                  <p>{billingAddress?.address}</p>
                </div>
              </div>
            </div>
            <div className="px-5 py-2 ">
              <AlertInfo title="Bilgilendirme"
                         message="Fatura adresinizi Müşteri Paneli -> Profil Ayarları -> Fatura Adreslerim kısmından düzenleyebilirsiniz." />
            </div>

            <div className="flex justify-end w-full pt-2 pb-6 pr-5">
              <Button onClick={() => setOpenModal(false)} buttonText="Tamam"
                      buttonRightIcon="ri-checkbox-circle-line" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BillingInfoModal;
